module.exports = __webpack_public_path__ + "static/media/cart-item.bd0543d4.jpg";